import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Stack } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { getAllBarberShop, getAllState, postBusinessClientUpdate } from "../../Service";
import { formatShopLabel } from "./index";

// Shown to a professional who isn't yet associated with a business (after registration, or on login).
// "Add" navigates to a sibling /add-shop page; on return, the newly created shop arrives via location state.
export default function BusinessSelectionWizard({ clientId, onSaved, professionalFirstName, professionalLastName, professionalPhoneNumber }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [businessOption, setBusinessOption] = useState([]);
  const [wizardShopId, setWizardShopId] = useState(location.state?.newShopId || "");
  const [wizardShopName, setWizardShopName] = useState(location.state?.newShopName || "");
  const [wizardError, setWizardError] = useState("");
  const [wizardLoader, setWizardLoader] = useState(false);

  useEffect(() => {
    // Stays on the guest-safe getAllBarberShop() - postAllShopList doesn't support the
    // stylist token yet (only Admin), even though this component is also used post-login.
    // State won't show here until backend finishes that (they've said it's planned but
    // not done yet). Do NOT switch this to postAllShopList until that's confirmed live -
    // it returns a real HTTP 400 for stylist tokens today.
    getAllState().then((stateRes) => {
      const stateList = stateRes.data.statusCode === 200 ? stateRes.data.stateList : [];
      const stateNameById = Object.fromEntries(stateList.map((s) => [s.stateId, s.stateName]));
      getAllBarberShop().then((res) => {
        if (res.data.statusCode === 200) {
          const options = res.data.shopList.map((shop) => ({
            label: formatShopLabel(shop, stateNameById),
            value: shop.shopId,
            name: shop.name,
          }));
          setBusinessOption(options);
        }
      });
    });
  }, []);

  const wizardBusinessHandleChange = (e) => {
    setWizardShopId(e.value);
    setWizardShopName(e.name);
    setWizardError("");
  };

  const handleWizardSave = () => {
    if (!wizardShopId) {
      setWizardError("Please select or add a business");
      return;
    }
    setWizardLoader(true);
    postBusinessClientUpdate({
      shopName: wizardShopName,
      shopId: wizardShopId,
      clientId: clientId,
    }).then((res) => {
      setWizardLoader(false);
      if (res.data.statusCode === 200) {
        onSaved();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusMessage,
        });
      }
    }).catch(() => setWizardLoader(false));
  };

  const handleAddOpen = () => {
    navigate(`${location.pathname}/add-shop`, {
      state: {
        clientId,
        firstName: professionalFirstName,
        lastName: professionalLastName,
        phoneNumber: professionalPhoneNumber,
      },
    });
  };

  return (
    <section className="login-bg register-bg">
      <Container>
        <Row className="justify-content-md-center">
          <Col md={5}>
            <div className="text-center">
              <img src="/images/logo.png" />
            </div>
            <h1 className="text-center">
              Select Your <span>Business</span>
            </h1>
            <Form.Label>
              Business Name <span>*</span>
            </Form.Label>
            <Row className="align-items-start business-name-row">
              <Col className="select-search-drp">
                <Select
                  className="selectSearch"
                  options={businessOption}
                  name="shopId"
                  value={wizardShopId ? { label: wizardShopName, value: wizardShopId, name: wizardShopName } : null}
                  onChange={wizardBusinessHandleChange}
                  placeholder="Search business name..."
                  isSearchable={true}
                />
              </Col>
              <Col xs="auto">
                <Button variant="secondary" onClick={handleAddOpen} style={{ marginTop: '-6px' }}>Add</Button>
              </Col>
            </Row>
            <p className="error">{wizardError}</p>
            <Stack gap={2} className="mx-autos">
              <Button variant="secondary" onClick={handleWizardSave} disabled={wizardLoader}>
                {wizardLoader ? "Saving..." : "Save"}
              </Button>
            </Stack>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
